(function () {
  'use strict';

  function normalizeNumber(text) {
    var value = parseInt(String(text || '').replace(/[^0-9]/g, ''), 10);
    return Number.isFinite(value) ? value : null;
  }

  function enhanceAllProductsPagination(root) {
    var paginations = (root || document).querySelectorAll('.tl-all-pagination');

    Array.prototype.forEach.call(paginations, function (pagination) {
      if (pagination.querySelector('.tl-all-pagination__status')) return;

      var currentNode = pagination.querySelector('.is-current, [aria-current="page"]');
      var currentPage = normalizeNumber(currentNode && currentNode.textContent) || 1;
      var totalPage = currentPage;

      Array.prototype.forEach.call(pagination.querySelectorAll('a, span'), function (node) {
        var num = normalizeNumber(node.textContent);
        if (num && num > totalPage) totalPage = num;
      });

      if (!currentNode) {
        Array.prototype.some.call(pagination.querySelectorAll('span'), function (node) {
          var num = normalizeNumber(node.textContent);
          if (num && !node.classList.contains('is-disabled')) {
            node.classList.add('is-current');
            node.setAttribute('aria-current', 'page');
            currentPage = num;
            return true;
          }
          return false;
        });
      } else {
        currentNode.setAttribute('aria-current', 'page');
      }

      Array.prototype.forEach.call(pagination.querySelectorAll('span'), function (node) {
        var text = node.textContent.trim();
        if (text === '…' || text === '...') node.classList.add('tl-all-pagination__ellipsis');
        if (node.classList.contains('is-disabled')) node.setAttribute('aria-disabled', 'true');
      });

      var status = document.createElement('p');
      status.className = 'tl-all-pagination__status treedix-category-pagination__status';
      status.textContent = 'Page ' + currentPage + ' of ' + totalPage;
      pagination.insertBefore(status, pagination.firstChild);
    });
  }

  function ensureCategoryFrame(row, tabs) {
    var frame = row.querySelector('.tl-all-category-frame');
    var parent = tabs.parentNode;
    if (!parent) return null;

    if (!frame) {
      frame = document.createElement('div');
      frame.className = 'tl-all-category-frame';
      parent.insertBefore(frame, tabs);
    }

    if (tabs.parentNode !== frame) {
      frame.appendChild(tabs);
    }

    var track = row.querySelector('.tl-all-category-scrollbar');
    if (track && track.parentNode !== frame) {
      frame.appendChild(track);
    }

    return frame;
  }

  function ensureCategoryScrollbar(frame) {
    var track = frame.querySelector('.tl-all-category-scrollbar');
    if (!track) {
      track = document.createElement('div');
      track.className = 'tl-all-category-scrollbar';
      track.setAttribute('aria-hidden', 'true');
      frame.appendChild(track);
    }

    var thumb = track.querySelector('.tl-all-category-scrollbar__thumb');
    if (!thumb) {
      thumb = document.createElement('span');
      thumb.className = 'tl-all-category-scrollbar__thumb';
      track.appendChild(thumb);
    }

    return { track: track, thumb: thumb };
  }

  function updateCategoryScrollIndicator(row, tabs, track, thumb) {
    var trackWidth = Math.max(0, track.clientWidth);
    var scrollable = tabs.scrollWidth > tabs.clientWidth + 1;
    row.classList.toggle('has-overflow', scrollable);

    if (!trackWidth) return;

    if (!scrollable) {
      thumb.style.width = '100%';
      thumb.style.transform = 'translate3d(0, 0, 0)';
      row.style.setProperty('--tl-all-category-scroll-thumb-width', '100%');
      row.style.setProperty('--tl-all-category-scroll-thumb-left', '0px');
      return;
    }

    var thumbWidth = Math.max(44, Math.round(trackWidth * (tabs.clientWidth / tabs.scrollWidth)));
    var maxScroll = tabs.scrollWidth - tabs.clientWidth;
    var maxTravel = Math.max(0, trackWidth - thumbWidth);
    var thumbLeft = maxScroll ? Math.round((tabs.scrollLeft / maxScroll) * maxTravel) : 0;

    thumb.style.width = thumbWidth + 'px';
    thumb.style.transform = 'translate3d(' + thumbLeft + 'px, 0, 0)';
    row.style.setProperty('--tl-all-category-scroll-thumb-width', thumbWidth + 'px');
    row.style.setProperty('--tl-all-category-scroll-thumb-left', thumbLeft + 'px');
  }

  function enhanceCategoryScrollerInstance(row, tabs) {
    if (!tabs) return;

    var frame = ensureCategoryFrame(row, tabs);
    if (!frame) return;

    var parts = ensureCategoryScrollbar(frame);
    var track = parts.track;
    var thumb = parts.thumb;
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;

    function updateScrollIndicator() {
      updateCategoryScrollIndicator(row, tabs, track, thumb);
    }

    if (!row.dataset.tlAllCategoryScroller) {
      row.dataset.tlAllCategoryScroller = 'true';
      tabs.addEventListener('scroll', function () {
        window.requestAnimationFrame(updateScrollIndicator);
      }, { passive: true });
      window.addEventListener('resize', updateScrollIndicator, { passive: true });
      window.addEventListener('orientationchange', updateScrollIndicator, { passive: true });
    }

    if (isMobile) {
      var activeTab = tabs.querySelector('.tl-all-category-tab.is-active, .tl-all-category-tab[aria-current="page"], .treedix-subcategory-pill.is-active, .treedix-subcategory-pill[aria-current="page"], .treedix-support-downloads__tab.is-active, .treedix-support-downloads__tab[aria-pressed="true"], a.is-active, a[aria-current="page"]');
      if (activeTab && typeof activeTab.scrollIntoView === 'function') {
        activeTab.scrollIntoView({ block: 'nearest', inline: 'center' });
      }
    }

    window.requestAnimationFrame(updateScrollIndicator);
  }

  function enhanceCategoryScrollers(root) {
    var scope = root || document;
    var instances = [
      { row: '.tl-all-products .tl-all-category-row', tabs: '.tl-all-category-tabs' },
      { row: '.treedix-category-page .treedix-category-subcats', tabs: '.treedix-category-tabs' },
      { row: '.treedix-popular-page .treedix-popular-categories', tabs: 'nav' },
      { row: '.treedix-support-downloads', tabs: '.treedix-support-downloads__tabs' }
    ];

    instances.forEach(function (instance) {
      Array.prototype.forEach.call(scope.querySelectorAll(instance.row), function (row) {
        enhanceCategoryScrollerInstance(row, row.querySelector(instance.tabs));
      });
    });
  }

  function enhanceAllProducts(root) {
    enhanceAllProductsPagination(root);
    enhanceCategoryScrollers(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { enhanceAllProducts(document); });
  } else {
    enhanceAllProducts(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    enhanceAllProducts(event.target || document);
  });
})();
